import { Routes } from '@angular/router';

export const manufacturerRoutes: Routes = [
    { path: 'products/:searchTitle', loadComponent: () => import('./manufacturer.component').then(m => m.ManufacturerComponent) },
    { path: 'product-details/:searchTitle', loadComponent: () => import('./manufacturer-product-details/manufacturer-product-details.component').then(m => m.ManufacturerProductDetailsComponent) },
];
